// extracted by mini-css-extract-plugin
export default {"menuMd":"index_menuMd_hGvU-","current":"index_current_edo9C"};